<nb-layout>
    <nb-layout-header fixed>
        <ngx-header></ngx-header>
    </nb-layout-header>

    <nb-layout-column>
        <div class="container-fluid notFound">
            <div class="col-12">
                <div class="lines">
                    <div class="bkgVectorCube mt-5 pt-5">
                        <div class="row justify-content-center pt-5 mt-5 h-100">
                            <div class="col-lg text-center align-self-center">
                                <h1>Crowdsale not found</h1>
                            </div>
                        </div>
                        <div class="row justify-content-center h-100">
                            <div class="col-lg text-center align-self-center">
                                <p>
                                    Sorry, we couldn't find the crowdsale you
                                    are looking for. Please add a contract
                                    address.
                                </p>
                            </div>
                        </div>

                        <div class="row justify-content-center h-100 pt-5 mt-5">
                            <button
                                size="small"
                                nbButton
                                status="primary"
                                (click)="onAddContractAddress()"
                            >
                                ADD CONTRACT
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nb-layout-column>
</nb-layout>
